// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import PipCodeRequestInfo from './pip-code-request-info';
import PipDaysToExpiryWidget from '../../../../pip/shared/components/pip-days-to-expiry-widget';
import SecureFooter from '../../../shared/components/secure-footer';

function handleApproval() {

    this.openPipCodeRequestModal(this.item, 'APPROVE');

}

function handleDenial() {

    this.openPipCodeRequestModal(this.item, 'DENY');

}

const PipCodeRequestsListItem = props =>
    <section className='pip-code-requests-list-item'>
        <main>
            <div className='product-header'>
                <Link
                    className='product-title'
                    rel='noopener noreferrer'
                    target='_blank'
                    to={`/products/${props.item.pin}`}
                >
                    {props.item.pin}
                </Link>
                <span className='pip-code-type'>{props.item.pipCodeType.value}</span>
                <PipDaysToExpiryWidget
                    daysLeft={props.item.daysRemaining}
                    metric='Y'
                    pipCompletionStatus=''
                    showIndicatorOnly={false}
                />
            </div>
            <PipCodeRequestInfo pipCodeRequest={props.item}/>
        </main>
        <SecureFooter
            onApprove={props::handleApproval}
            onDeny={props::handleDenial}
            securityFeature='TCSM_PIP_CODE_PROCESS'
            securityModule='TCSM'
        />
    </section>;

PipCodeRequestsListItem.displayName = 'PipCodeRequestsListItem';
PipCodeRequestsListItem.propTypes = {
    item: PropTypes.instanceOf(PipCode).isRequired,
    openPipCodeRequestModal: PropTypes.func.isRequired
};

export default PipCodeRequestsListItem;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/pip-code-requests/pip-code-requests-list-item.js